<template>
  <div>
    <v-dialog v-model="dialog" max-width="800" scrollable>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon small color="primary" v-bind="attrs" v-on="on">
          <v-icon small color="primary" class="mx-2"
            >mdi-information-outline</v-icon
          >
        </v-btn>
      </template>
      <v-card>
        <div class="orangeCardTitle d-flex flex-row pa-3">
          <div class="title">Tear Film Calculations</div>
          <v-spacer></v-spacer>
          <v-btn icon text @click="dialog = false">
            <v-icon color="primary">mdi-close</v-icon></v-btn
          >
        </div>
        <v-card-text>
          <div v-for="lensNum in [0, 1]" :key="lensNum">
            <div
              class="d-flex flex-column flex-sm-row flex-wrap align-center my-4"
            >
              <v-card class="aBox" :color="colors[lensNum]" v-if="bc[lensNum]">
                <div class="overline">Lens {{ lensNum + 1 }} BC</div>
                <optical-cross-image
                  :dimensions="crossSize"
                  :obj="bc[lensNum]"
                  type="keratometry"
                  class="mx-auto"
                ></optical-cross-image>
                <div class="caption crossCaption py-2">
                  {{ prettyKstringDandMM(bc[lensNum].k1) }}
                </div>
              </v-card>
              <v-icon x-large color="blue">mdi-minus</v-icon>
              <v-card class="aBox" :color="colors[lensNum]" v-if="keratometry">
                <div class="overline">Keratometry</div>
                <optical-cross-image
                  :dimensions="crossSize"
                  :obj="keratometry"
                  :showHeatmap="true"
                  type="keratometry"
                  class="mx-auto"
                ></optical-cross-image>
                <div class="caption crossCaption px-2 py-2">
                  {{ prettyFullKstringDandMM(keratometry) }}
                </div>
              </v-card>
              <v-icon x-large color="blue">mdi-equal</v-icon>
              <v-card
                class="aBox"
                :color="colors[lensNum]"
                v-if="tearlens[lensNum]"
              >
                <div class="overline">Lens {{ lensNum + 1 }} Tear Power</div>
                <optical-cross-image
                  :obj="tearlens[lensNum]"
                  :dimensions="crossSize"
                  type="NaFl"
                  :showHeatmap="true"
                  class="mx-auto"
                ></optical-cross-image>
                <div class="caption crossCaption py-2">
                  {{ prettyStringMinus(tearlens[lensNum]) }}
                </div>
              </v-card>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RxMethods from "@/assets/js/cls/RxMethods";
import OpticalCrossImage from "@/components/clStuff/OpticalCrossImage";

export default {
  name: "TearLensCalcDialog",
  components: {
    OpticalCrossImage,
  },
  mixins: [RxMethods],
  props: {
    bc: {
      type: Array,
      default: function () {
        return [null, null];
      },
    },
    colors: {
      type: Array,
      default: function () {
        return ["#fcf5f5", "#fffce2"];
      },
    },
    tearlens: {
      type: Array,
      default: function () {
        return [null, null];
      },
    },
    keratometry: null,
  },
  data: function () {
    return { dialog: false, crossSize: 80 };
  },
  methods: {},
  computed: {
    baseCurveObjects: function () {
      let rtn = [null, null];
      if (this.bc[0]) rtn[0] = this.setKeratometryParameters(null, this.bc[0]);
      if (this.bc[1]) rtn[1] = this.setKeratometryParameters(null, this.bc[1]);
      return rtn;
    },
  },
};
</script>

<style scoped>
.aBox {
  /* min-height: 180px; */
  text-align: center;
}
</style>
